export function roundIfNecessary(value: number, decimals: number) {
    return Number(`${Math.round(Number(`${value}e${decimals}`))}e-${decimals}`);
}
